import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  BoxProps,
  Collapse,
  Divider,
  Heading,
  HStack,
  Skeleton,
  Stack,
  Text,
} from '@chakra-ui/react';
import { FC, ReactElement } from 'react';

import { Card } from './Card';

interface CollapsibleContentCardProps extends BoxProps {
  header?: string;
  contentDescription?: string;
  icon?: ReactElement;
  isLoading?: boolean;
}
/*<IconTooltip text={description}></IconTooltip>*/
export const CollapsibleContentCard: FC<CollapsibleContentCardProps> = ({ header, contentDescription, children, icon, isLoading, ...boxProps }) => {
  return (
    <Accordion allowToggle>
      <AccordionItem border="none">
        <Card {...boxProps}>
          <HStack spacing="4" py={4} px={4}>
            {isLoading ? <Skeleton height="20px" speed={2} fadeDuration={8} /> : icon}
            <Box width={'full'} ml={2}>
              {!isLoading ? header && <Heading size="xs">{header}</Heading> : <Skeleton height="20px" speed={2} fadeDuration={8} />}
              {!isLoading ? (
                contentDescription && (
                  <Text color="muted" fontSize="sm">
                    {contentDescription}
                  </Text>
                )
              ) : (
                <Skeleton height="20px" speed={2} fadeDuration={8} />
              )}
            </Box>
            <AccordionButton w={'fit-content'}>
              <AccordionIcon />
            </AccordionButton>
          </HStack>
          <Divider />
          <AccordionPanel>
            <Stack w={'full'} direction={['column']} p={6}>
              {isLoading ? (
                <Skeleton height="300px" speed={2} fadeDuration={8} />
              ) : (
                <Collapse in={!isLoading} animateOpacity>
                  {children}
                </Collapse>
              )}
            </Stack>
          </AccordionPanel>
        </Card>
      </AccordionItem>
    </Accordion>
  );
};
